export const subStringSearch = (text: string, searchText: string): boolean => {
  return text.toLowerCase().indexOf(searchText) !== -1
}
